import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export const handleLogInLink = async (token: string) => {
  const { body } = await api.post(
    "/beepaidgo/handle-login-link-session/",
    {
      body: { token },
    }
  )
  queryClient.invalidateQueries({
    queryKey: [CURRENT_USER_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [CURRENT_TENANT_QUERY_KEY],
  })
  return body
}
